import React, { Component } from 'react';
import Header from '../../components/Header';
import AnalyticsHeader from '../../components/Wholesaler/AnalyticsHeader';
import Sidebar from '../../components/Sidebar';
import moment, { relativeTimeRounding } from 'moment';
import filterIcon from '../css/dark/img/filter.svg';
import 'bootstrap-daterangepicker/daterangepicker.css';
import $ from 'jquery';
import List from '../List';
import Column_Pie from '../Column_Pie';
import FilterTagCom from '../FilterTag';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";

class Pharmacies extends Component {
    constructor(props) {
        super(props);
        var startdate = new Date();
        startdate.setDate(startdate.getDate() - 30);
        var enddate = new Date();
        if (localStorage.getItem('User_Start_Date') != "" && localStorage.getItem('User_Start_Date') != null && localStorage.getItem('User_Start_Date') != undefined) {
            startdate = localStorage.getItem('User_Start_Date');
        }
        if (localStorage.getItem('User_End_Date') != "" && localStorage.getItem('User_End_Date') != null && localStorage.getItem('User_End_Date') != undefined) {
            enddate = localStorage.getItem('User_End_Date');
        }
        let filterdatalocal = localStorage.getItem('Advance_Filter');
        if (filterdatalocal == null || filterdatalocal == '' || filterdatalocal == undefined || filterdatalocal == "null") {
            filterdatalocal = '';
        }
        var _roletype = '', _rolename = '';
        var _wh_Id = 0;
        try {
            var userdata = JSON.parse(localStorage.getItem('user'));
            if (userdata.userrole == "Distributor" && userdata.wholesaler == "Avenelllllll") {
                _roletype = "avdistributor";
                _rolename = userdata.email;
                _wh_Id = userdata.wholesaler_Id;
            }
            else if (userdata.userrole == "Distributor" && userdata.wholesaler != "Avenelllll") {
                _roletype = "distributor";
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
            else {
                _roletype = userdata.userrole;
                _rolename = userdata.paramsname;
                _wh_Id = userdata.wholesaler_Id;
            }
        }
        catch (error) { }
        try {
            this.state = {
                WidgetList: [],
                startDate: startdate,
                endDate: enddate,
                AnalyticData: [],
                userdata: JSON.parse(localStorage.getItem('user')),
                scrollArray: {},
                graphData: [],
                AnalyticList: [],
                FilterTagMatch: [],
                FilterTagList: filterdatalocal,
                roletype: _roletype,
                rolename: _rolename,
                wh_Id: _wh_Id
            };
        }
        catch (error) { }
        let newDate = new Date();
        localStorage.setItem('Filter_Last_Update_Time', newDate);
        this.handleCalendar = this.handleCalendar.bind(this);
    }
    handleCollapse = () => {
        if ($(".sidebar-section").hasClass("intro")) {
            $(".menu-text").css('width', 'auto');
            $(".sidebar-submenu").css('width', '100%');
            $(".sidebar-submenu").css('height', 'auto');
            $(".down-arrow").css('display', 'block');
            $(".sidebar-section").animate({
                width: 270 + 'px'
            }, 1000);
            $(".collapseButton").animate({
                left: 246 + 'px'
            }, 1000, function () {
                $("#chartjs-tooltip").hide();
                $(".collapseButton").removeClass('active');
            });
            $(".anylytics.pharmacy").animate({
                marginLeft: 13 + 'px'
            }, 1000);
            $(".sidebar-section").removeClass('intro');
        } else {
            $(".sidebar-section").animate({
                width: 90 + 'px'
            }, 1000, function () {
                $(".menu-text").css('width', '0px');
                $(".sidebar-submenu").css('width', '0px');
                $(".sidebar-submenu").css('height', '0px');
                $(".down-arrow").css('display', 'none');
                $('.sidebar-submenu').hide();
                $('body').toggleClass('sub-menu-active');
            });
            $(".collapseButton").animate({
                left: 66 + 'px'
            }, 1000, function () {
                $(".collapseButton").addClass('active')
            });
            $(".anylytics.pharmacy").animate({
                marginLeft: -170 + 'px'
            }, 1000);
            $(".sidebar-section").addClass('intro');
        }
        var $head8 = $(".widget-iframe").contents().find("head");
        $head8.append($("<link/>",
            { rel: "stylesheet", href: "/table.css", type: "text/css" }));
    }
    componentDidMount() {
        try {
            if (userService.Check_LoggedIn_Status() != 'Login') {
                this.changeData();
                $('body').addClass('analyticPage');
                $('.sidebar-submenu').show();
                $(".analytics-menu").click(e => {
                    if ($('.collapseButton').hasClass("active")) {
                        this.handleCollapse();
                        $('.sidebar-submenu').show();
                        $('body').toggleClass('sub-menu-active');
                    }
                });
            }
        } catch (error) { }
    }
    componentWillUnmount() {
        $('body').removeClass('analyticPage');
    }
    handleCalendar(e, picker) {
        let changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        localStorage.setItem('User_Start_Date', changedStartDate);
        localStorage.setItem('User_End_Date', changedEndDate);
        this.changeData(true, changedStartDate, changedEndDate);
        try {
            $('.first-one .form-control').val(changedStartDate);
            $('.second-one .form-control').val(changedEndDate);
        }
        catch (error) {
        }
    }
    handleChange = (e) => {
        this.setState({
            ...this.state,
            dashboardName: e
        })
    }
    handleChangeStartEnd = (d) => {
        try {
            this.setState({
                ...this.state,
                startDate: d.split('-')[0],
                endDate: d.split('-')[1]
            });
            this.changeData('', d.split('-')[0], d.split('-')[1]);
        }
        catch (error) {
        }
    }
    changeData(dateChanged, stdate, endate) {
        var wname = '';
        var startDateObj = '';
        var endDateObj = '';
        if (dateChanged == undefined) {
            startDateObj = this.state.startDate;
            endDateObj = this.state.endDate;
        }
        else {
            startDateObj = stdate;
            endDateObj = endate;
        }

        var AdFilterJson = '';
        try {
            AdFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'))
            if (AdFilterJson != null && AdFilterJson != '' && AdFilterJson != undefined && AdFilterJson != "null") {
                this.setState({ FilterTagList: JSON.stringify(AdFilterJson) });
            }
            else {
                this.setState({ FilterTagList: '' });
            }
        }
        catch (error) {
            this.setState({ FilterTagList: '' });
        }
        var startDate = new moment(startDateObj).format("YYYYMMDD");
        var endDate = new moment(endDateObj).format("YYYYMMDD");
        let changedStartDate = new moment(startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(endDate).format("MM/DD/YYYY");
        this.setState({ startDate: changedStartDate, endDate: changedEndDate });
        var Table_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var PatientSavings_Pharmacy_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "list\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var PharmacyChain_PaidClaims_PostData_RequestJson = "{\"wname\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\",\"start_date\"" + ":\"" + startDate + "\",\"end_date\"" + ":\"" + endDate + "\",\"rcount\"" + ":" + 30 + ",\"chart_type\"" + ":\"" + "pielist\"" + ",\"filtertime\"" + ":\"" + localStorage.getItem('Filter_Last_Update_Time') + "\",\"rxsClaimType\"" + ":\"" + localStorage.getItem('Updated_HD_Type') + "\",\"wholesaler_id\"" + ":\"" + this.state.userdata["wholesaler_Id"] + "\"}";
        var APIBaseURL = "";
        APIBaseURL = '/api/admin';
        if (this.state.userdata.isLegacyUser == true) {
            this.setState({
                dashboardName: wname,
                graphData: [
                    {
                        url: APIBaseURL + "/pharmacy_transaction_new",
                        type: "List",
                        title: "Transactions by Pharmacy",
                        Subtitle: "Number of transactions at each pharmacy",
                        ColorCode: "#ffba10",
                        XlabelString: "",
                        YlabelString: "",
                        id: "WPharmacyTransaction1",
                        RequestJson: Table_Pharmacy_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL + "/patientsavings_new",
                        type: "List",
                        title: "Patient Savings by Pharmacy",
                        Subtitle: "Patient savings in $ at each pharmacy",
                        ColorCode: "#ffba10",
                        XlabelString: "",
                        YlabelString: "",
                        id: "WPatientSavingTransaction",
                        RequestJson: PatientSavings_Pharmacy_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL + "/pharmacychainpaidclaims",
                        type: "Column_Pie",
                        title: "Paid Claims by Pharmacy Chain",
                        Subtitle: "Paid claims broken down by Pharmacy Chain",
                        XlabelString: "States",
                        YlabelString: "Paid Claims",
                        ColorCode: "#ffba10",
                        DataType: "Pharmacy Chain",
                        id: "PharmacyChainPaidClaimsAdmin",
                        RequestJson: PharmacyChain_PaidClaims_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    }
                ]
            });
        } else {
            this.setState({
                dashboardName: wname,
                graphData: [
                    {
                        url: APIBaseURL + "/pharmacy_transaction_new",
                        type: "List",
                        title: "Transactions by Pharmacy",
                        Subtitle: "Number of transactions at each pharmacy",
                        ColorCode: "#ffba10",
                        XlabelString: "",
                        YlabelString: "",
                        id: "WPharmacyTransaction1",
                        RequestJson: Table_Pharmacy_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL + "/patientsavings_new",
                        type: "List",
                        title: "Patient Savings by Pharmacy",
                        Subtitle: "Patient savings in $ at each pharmacy",
                        ColorCode: "#ffba10",
                        XlabelString: "",
                        YlabelString: "",
                        id: "WPatientSavingTransaction",
                        RequestJson: PatientSavings_Pharmacy_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    },
                    {
                        url: APIBaseURL + "/pharmacychainpaidclaims",
                        type: "Column_Pie",
                        title: "Paid Claims by Pharmacy Chain",
                        Subtitle: "Paid claims broken down by Pharmacy Chain",
                        XlabelString: "States",
                        YlabelString: "Paid Claims",
                        ColorCode: "#ffba10",
                        DataType: "Pharmacy Chain",
                        id: "PharmacyChainPaidClaimsAdmin",
                        RequestJson: PharmacyChain_PaidClaims_PostData_RequestJson,
                        RequestJson1: JSON.stringify(AdFilterJson)
                    }
                ]
            });
        }
    }
    handeChangefilter = (e) => {
        try {
            this.setState({
                ...this.state,
                userdata: JSON.parse(localStorage.getItem('user'))
            });
            var APIBaseURL = "";
            var startDateObj = $('.first-one .form-control').val();
            var startDate = new moment(startDateObj).format("YYYYMMDD");
            var endDateObj = $('.second-one .form-control').val();
            var endDate = new moment(endDateObj).format("YYYYMMDD");
            var IsCall = false;
            try {
                if ((localStorage.getItem('Prev_Filter_Status').toLowerCase() != localStorage.getItem('Updated_Filter_Status').toLowerCase()) || (localStorage.getItem('Prev_AdFilter_Status') != localStorage.getItem('Updated_AdFilter_Status')) || (localStorage.getItem('Updated_HD_Type') != localStorage.getItem('Prev_HD_Type'))) {
                    IsCall = true;
                }
                else {
                    IsCall = false;
                }
            }
            catch (error) {
                IsCall = false;
            }
            try {
                if (endDate != this.state.endDate || startDate != this.state.startDate || IsCall == true) {
                    if (IsCall == true) {
                        localStorage.setItem('Prev_Filter_Status', localStorage.getItem('Updated_Filter_Status'));
                        if (localStorage.getItem('Updated_AdFilter_Status') == "null" || localStorage.getItem('Updated_AdFilter_Status') == null) {
                            localStorage.setItem('Prev_AdFilter_Status', null);
                            localStorage.setItem('Updated_AdFilter_Status', null);
                        }
                        else {
                            localStorage.setItem('Prev_AdFilter_Status', localStorage.getItem('Updated_AdFilter_Status'));
                        }
                        if (localStorage.getItem('Updated_HD_Type') == "null" || localStorage.getItem('Updated_HD_Type') == null) {
                            localStorage.setItem('Prev_HD_Type', null);
                            localStorage.setItem('Updated_HD_Type', null);
                        }
                        else {
                            localStorage.setItem('Prev_HD_Type', localStorage.getItem('Updated_HD_Type'));
                        }
                    }
                    this.changeData('', startDate, endDate);
                }
            } catch (error) {
            }
        } catch (error) { }
    }
    render() {
        try {
            let usertype = userService.Get_User_Type();
            if (userService.Check_LoggedIn_Status() == 'Login') {
                return <Redirect to="/login" />
            }
            if (usertype.toLowerCase() == 'distributor') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'subadmin') {
                return <Redirect to='/pageNotFound' />
            }
            else if (usertype.toLowerCase() == 'wholesaler') {
                return <Redirect to='/pageNotFound' />
            }
        } catch (error) { }
        return (
            <div className="anylytics pharmacy">
                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                <Header />
                <h2 className="dashboardHeading">Pharmacies<span className="beta-link"><span className="beta">Beta</span></span></h2>
                <AnalyticsHeader handleChange={this.handeChange} handleChangeDateNew={this.handleChangeStartEnd} handeChangefilter={this.handeChangefilter} startDate={this.state.startDate} endDate={this.state.endDate} />
                <Sidebar AnalyticList={this.props.AnalyticData} />
                <div className="dashboard-content-parent">
                    <div className="newBoard">
                        <div className="parent">
                            <div className="contentContainer">
                                <div>
                                    <div className='row'>
                                        <div className='double-column'>
                                            <div className="dashboard-container" id="dashboard-container">
                                                <a href="javascript:void('0')" className="collapseButton" onClick={this.handleCollapse}>Collapse Button</a>
                                                <FilterTagCom Rolename={this.state.rolename} wh_Id={this.state.wh_Id} Roletype={this.state.roletype} df={new moment(this.state.startDate).format("YYYYMMDD")} dt={new moment(this.state.endDate).format("YYYYMMDD")} handlechangea={this.handeChangefilter} FilterTags={this.state.FilterTagList} Loading={true} />
                                                {
                                                    this.state.graphData.map((item, index, id) => {
                                                        var k = null;
                                                        return (
                                                            ((this.state.dashboardName.replace(" Dashboard (wholesaler)", "").toLowerCase() == 'patient rx discount' && item.title == 'Transactions by Prescriber')) ? null :
                                                                <div id={item.id + index} className={`${item.type == "Bar" ? "widget ui-draggable ui-resizable" : item.type == "Line" ? "widget ui-draggable ui-resizable second" : "widget ui-draggable ui-resizable customScroll third"}${item.id == "WPharmacyTransaction1" ? ' layout-not-margin list' : ''}${item.id == "WPatientSavingTransaction" ? ' layout-left-margin list' : ''}${item.id == "PharmacyChainPaidClaimsAdmin" ? ' layout-not-margin list' : ''}`} key={"graph-widget" + index}>
                                                                    {/* <div className="widget-head" key={"graph-widget-head" + index}>
                                                                        <h3>
                                                                            <a>{item.title}</a>
                                                                        </h3>
                                                                        <p>
                                                                            <a>{item.Subtitle}</a>
                                                                        </p>
                                                                    </div>*/}
                                                                    <div className="widget-content" key={"graph-widget-content" + index}>
                                                                        <div className="custom-scroll">
                                                                            {
                                                                                <div className="scroll-content" style={{ height: this.state.scrollArray[this.state.graphData[index].id] }}>
                                                                                    {item.type == "List" ? <List data={item} key={"listgraph" + index} _Index={index} handlechangea={this.handeChangefilter} /> : null}
                                                                                    {item.type == "Column_Pie" ? <Column_Pie data={item} key={"columnpiegraph" + index} _Index={index} handlechangea={this.handeChangefilter} /> : null}
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                    <div className="widget-foot">
                                                                        &nbsp;
                                                                    </div>
                                                                </div>
                                                        )
                                                    })
                                                }
                                                <div className="sortby">
                                                    <a href="javascript:void('0')"><img src={filterIcon} alt="filterIcon" />Calendar</a>
                                                    <a href="javascript:void('0')"><img src={filterIcon} alt="filterIcon" />Filter</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Pharmacies;